import LabGrid from "@/components/labs/LabGrid";

export default function HomePage() {
	return (
		<main id="main-content" className="max-w-7xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
			<LabGrid />
		</main>
	);
}
